<div class="modal-header border-0 px-lg-8 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-8 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
			</div>
			<div class="row my-2">
				<form id="formEdit" [formGroup]="formEdit" (ngSubmit)="onSubmit()">
					<div class="row my-4">
						<label for="title" class="form-label theme-main-color fw-bold"
							>Titre</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="title"
							name="title"
							formControlName="title"
							[ngClass]="{
								'is-invalid': title.invalid,
								'is-valid': title.dirty && title.valid
							}"
						/>
						<div
							*ngIf="title.invalid && (title.dirty || title.touched)"
							class="text-danger"
						>
							<span *ngIf="title.errors?.required"> Un titre est requis</span>
							<span *ngIf="title.errors?.pattern">
								Le titre ne peut pas comporter de chiffre</span
							>
							<span *ngIf="title.errors?.maxLength"> Le titre est trop long</span>
						</div>
					</div>

					<div class="row my-4">
						<label for="title" class="form-label theme-main-color fw-bold"
							>Type</label
						>

						<select
							class="form-select"
							id="type"
							formControlName="type"
							name="type">
							<option *ngFor="let key of keys(notificationTypes)" [ngValue]="key">{{notificationTypes[key]}}

							</option>
						</select>
						

					</div>

					<div class="row my-4">
						<label for="title" class="form-label theme-main-color fw-bold"
							>Message</label
						>
						<!-- <textarea
							class="form-control"
							id="message"
							formControlName="message"
							[ngClass]="{
								'is-invalid': message.invalid,
								'is-valid': message.dirty && message.valid
							}"
						></textarea> -->
						<div class="NgxEditor__Wrapper">
							<ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
							<ngx-editor [editor]="editor" formControlName="message"></ngx-editor>
						</div>
						
					</div>

					<div class="row my-4">
						<div
							class="form-check form-switch ms-2"
						>
							<input
								class="form-check-input theme-main-border-color"
								type="checkbox"
								id="actif"
								formControlName="actif"
								[ngClass]="{
									'theme-main-color-check': actif.value
								}"
							/>
							<label class="form-check-label text-dark" for="actif"
								>Actif</label
							>
						</div>
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formEdit.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formEdit"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
